import { render, staticRenderFns } from "./UserSignIn.vue?vue&type=template&id=bbcf307a&scoped=true&"
import script from "./UserSignIn.vue?vue&type=script&lang=js&"
export * from "./UserSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf307a",
  null
  
)

export default component.exports